import React from 'react';
import { Box, Card, Typography } from '@mui/joy';
import { BRAND } from '../brand';

const StockListCard = ({ title, fields = [], onClick, subtitle }) => (
  <Card
    variant="outlined"
    onClick={onClick}
    sx={{
      p: 2,
      cursor: onClick ? 'pointer' : 'default',
      transition: 'background-color 0.15s, border-color 0.15s',
      '&:hover': onClick
        ? { bgcolor: 'primary.50', borderColor: 'primary.300' }
        : undefined,
      '&:active': onClick ? { bgcolor: 'primary.100' } : undefined
    }}
  >
    <Typography level="title-md" sx={{ color: BRAND.colors.navy, fontWeight: 600, mb: subtitle ? 0.25 : 1 }}>
      {title}
    </Typography>
    {subtitle && (
      <Typography level="body-xs" sx={{ color: 'text.tertiary', mb: 1 }}>
        {subtitle}
      </Typography>
    )}
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
      {fields.map((field) => (
        <Box
          key={field.label}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: 2,
            py: 0.25
          }}
        >
          <Typography level="body-sm" sx={{ color: 'text.secondary', flexShrink: 0 }}>
            {field.label}
          </Typography>
          <Box sx={{ textAlign: 'right', minWidth: 0 }}>
            {typeof field.value === 'string' || typeof field.value === 'number' ? (
              <Typography level="body-sm" sx={{ fontWeight: 500 }}>
                {field.value}
              </Typography>
            ) : (
              field.value
            )}
          </Box>
        </Box>
      ))}
    </Box>
  </Card>
);

export default StockListCard;
